import { render, staticRenderFns } from "./RelativeContacts.vue?vue&type=template&id=417d5d8e&scoped=true"
import script from "./RelativeContacts.vue?vue&type=script&lang=js"
export * from "./RelativeContacts.vue?vue&type=script&lang=js"
import style0 from "./RelativeContacts.vue?vue&type=style&index=0&id=417d5d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d5d8e",
  null
  
)

export default component.exports